import React from "react"
import { TheProvider } from "./src/utils"

export const wrapRootElement = ({ element }) => (
  <TheProvider>{element}</TheProvider>
)
